import { showPriceSaleWithDetailText } from "../../../../setup/settings/__product"

export default function ProductPriceDetailWithText() {
    return(
        <div className="price_detail_container">
            <p className='oldPrice_Detail_text'>{showPriceSaleWithDetailText.nowPriceText}</p>
            <p className='nowPrice_Detail_text'>{showPriceSaleWithDetailText.oldPriceText}</p>       
        </div>
    )
}